/**
 * PanelHeaderTitle — the name a panel's header row carries: 16/24 semibold in
 * the high-contrast foreground, truncated to the room the row leaves it.
 */

import type { ReactElement, ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface Props {
    children: ReactNode;
    className?: string;
}

export const PanelHeaderTitle = ({ children, className }: Props): ReactElement => (
    <h2 className={cn('occ-panel-header-title', className)}>{children}</h2>
);
